// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GatewayOutlinedSvg from "@ant-design/icons-svg/es/asn/GatewayOutlined";
import AntdIcon from '../components/AntdIcon';

var GatewayOutlined = function GatewayOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GatewayOutlinedSvg
  }));
};

GatewayOutlined.displayName = 'GatewayOutlined';
export default React.forwardRef(GatewayOutlined);